import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ts_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Gracefully surface the email-verification gate (403 email_not_verified) instead of a raw error.
let _verifyPromptAt = 0;
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const detail = error.response?.data?.detail;
    if (error.response?.status === 403 && detail === "email_not_verified") {
      const now = Date.now();
      if (now - _verifyPromptAt > 4000) {
        _verifyPromptAt = now;
        toast.error("Please verify your email to continue", {
          description: "Check your inbox for the verification link.",
          action: {
            label: "Resend email",
            onClick: async () => {
              try {
                await api.post("/auth/resend-verification");
                toast.success("Verification email sent. Please check your inbox.");
              } catch {
                toast.error("Could not resend right now. Please try again shortly.");
              }
            },
          },
        });
      }
    }
    return Promise.reject(error);
  }
);

export default api;
